import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Vue3Toasity, { type ToastContainerOptions } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import '@vueform/multiselect/themes/default.css';

createApp(App)
    .use(store)
    .use(router)
    .use(
        Vue3Toasity,
        {
            autoClose: 3000,
        } as ToastContainerOptions,
    )
    .mount('#app');
